let View = require('views/view')
let app = require('application')

module.exports = View.extend({
  template: require('views/templates/division/division'),
  events () { // On récupère ici les events de view (les event globaux) pis on ajoute les spécifiques a cette vue (SOURCE : http://stackoverflow.com/questions/9403675/backbone-view-inherit-and-extend-events-from-parent)
    return _.extend({}, View.prototype.events, {
      'click #btn-show-form-division': 'showFormEvent',
      'click .division-hide-form': 'hideFormEvent',
      'click .edit-division': 'update',
      'click .delete-division': 'delete'
    })
  },
  list () {
    let data = $('#form-pagination').serialize()
    this.hideFormEvent()

    $('#division-list').html('<i class="fa fa-refresh fa-spin"></i> Chargement en cours...')

    app.ajax({
      url: '/division',
      data,
      success: (...args) => this.refreshList(...args)
    })
  },
  refreshList (divisions, status, xhr) {
    $('#division-list').html(require('views/templates/division/list')({
      divisions,
      searchTerms: xhr.getResponseHeader('ps-search-term'),
      total: xhr.getResponseHeader('ps-total-row')
    })).show()

    app.initList()
  },
  update (e) {
    if (e) e.preventDefault()
    let id = $(e.currentTarget).closest('tr').data('id')
    if (id) {
      app.ajax({
        url: '/division',
        data: { id },
        complete: app.onComplete({
          success: (res) => this.showFormEvent(res)
        })
      })
    }
  },
  showFormEvent (data) {
    $('#division-form-ctn').empty().html(require('views/templates/division/form')(data)).show()
    $('#btn-show-form-division').attr('disabled', true)
    this.prepareFormEvent()
  },
  hideFormEvent (e) {
    if (e) e.preventDefault()
    $('#division-form-ctn').hide().empty()
    $('#btn-show-form-division').attr('disabled', false)
  },
  prepareFormEvent (e) {
    app.ajax({
      url: '/sport',
      complete: app.onComplete({
        success: (d) => {
          let data = d.map(({sport, id_sport}) => ({ id: id_sport, text: `${sport}` }))
          app.select2('#id_sport-ui', { data })
        }
      })
    })

    app.select2('#id_pays-ui', {
      ajax: {
        url: '/pays',
        type: 'GET',
        dataType: 'json',
        delay: 250,
        data: function (params) {
          return {
            q: params.term,
            'no-limit': 1
          }
        },
        processResults: function (data) {
          return {
            results: $.map(data, ({pays, id_pays}) => ({ id: id_pays, text: `${pays}` }))
          }
        }
      },
      minimumInputLength: 1
    })



    app.validator('division-form',[
      { name: 'division', display: 'Nom de la division', rules: 'required' },
      { name: 'id_sport', display: 'Sport associé', rules: 'required' },
      { name: 'id_pays', display: 'Pays associé', rules: 'required' }
    ], this.processFormEvent.bind(this))
  },
  processFormEvent (e) {
    if (e) e.preventDefault()
    let type = 'POST'
    if ($('#id-division').val()) {
      type = 'PUT'
    }
    let data = $('#division-form').serialize()
    app.ajax({
      url: '/division',
      type,
      data,
      complete: app.onComplete({
        success: (r) => this.list(r)
      })
    })
  },
  delete (e) {
    if (e) e.preventDefault()
    let id = $(e.currentTarget).closest('tr').data('id')
    bootbox.confirm({
      message: "Êtes vous sûr ?",
      buttons: {
        confirm: {
          label: 'Oui',
          className: 'btn-success'
        },
        cancel: {
          label: 'Non',
          className: 'btn-danger'
        }
      },
      callback: (result) => {
        if (result) {
          app.ajax({
            url: '/division',
            type: 'DELETE',
            data: { id },
            complete: app.onComplete({
              success: (r) => {
                $('.row-division[data-id=' + id + ']').fadeOut('slow')
              }
            })
          })
        }
      }
    });
  }

})
